import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";

import { SettingOutlined } from "@ant-design/icons";

import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";
import {
  AccountFacility,
  handleWalletAccountActionButtons,
} from "../../../../components/facilities/WalletAccountFacility";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";

import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";
import Charges from "./tabs/Charges";
import SubWallet from "./tabs/SubWallet";
import Transactions from "./tabs/Transactions";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewWalletAccount = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  // console.log(state);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showInterestChecked, setShowInterestChecked] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });
  const [walletAccountDetails, setWalletAccountDetails] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [chargesList, setChargesList] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [subWalletListData, setSubWalletListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const [useForm] = Form.useForm();

  const walletAccountData = {};

  const tabList = [
    {
      key: "transactions",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Transactions</span>
        </div>
      ),
    },
    {
      key: "subWallet",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Sub-Wallets</span>
        </div>
      ),
    },
    {
      key: "charges",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Charges</span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getWalletAccountById();
  }, []);

  const getWalletAccountById = (offset = 0, _limit = Number(tableCount)) => {
    const url = `${apiConfig.WalletAccount}/${state.id}`;
    const params = {
      associations: "all",
      offset: offset,
      limit: _limit,
      chargeStatus: "all",
    };

    let body = {
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setTotalItems(objDetail?.savingsAccountData?.transactionSize);
        let tempSubWalletList = [];
        let tempChargesArray = [];
        let tempTransactionsArray = [];

        setWalletAccountDetails(objDetail);

        objDetail?.childWalletData?.forEach((element, i) => {
          tempSubWalletList.push({
            key: element?.id,
            id: element?.id,
            nubanNumber: element?.nuban || "-",
            parentName: element?.parentName || "-",
            name: element?.name || "-",
            status: element?.savingsAccountData?.status?.value || "-",
            // kycLevel: element?.kycLevel.value || "-",
          });
        });

        setSubWalletListData(tempSubWalletList);
        objDetail?.savingsAccountData?.transactions?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.date
              ? BOM.DateTime(element?.date, "only-date")
              : "-",
            transactionType: element?.transactionType
              ? element?.transactionType?.value
              : "-",
            amount: element.amount,
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            transactionTypeDetail: element.transactionType,
          });
        });

        objDetail?.savingsAccountData?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? BOM.SubstringFormat(element?.name, 20) : "-",
            penalty: element?.penalty ? "Penalty" : "Fee",
            paymentDueAt: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            dueAsOf: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            repeatsOn: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            calculationType: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            due: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOrPercentage}`
              : "-",
            paid: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountPaid}`
              : "-",
            waived: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountWaived}`
              : "-",

            outstanding: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOutstanding}`
              : "-",
            status: handleFlgStatus(
              element?.isActive ? "active" : "closed",
              {},
              true,
            ),
          });
        });

        setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        setMenuProps({
          items: handleWalletAccountActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleWalletAccountActionButtons(objDetail).find(
              (element) => element.key === e.key,
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      actionLabel: item.label,
                      contractObj: objDetail,
                    },
                  });
              }
            }
          },
        });
        setIsLoading(false);
      }
    });
  };

  const getChargeDetailById = (arg) => {
    const url = `${apiConfig.WalletAccount}/${arg.id}`;
    const params = {
      associations: "all",
      offset: 0,
      limit: 2,
      chargeStatus: "all",
    };

    let body = {
      session,
      params,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        console.log(objDetail);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    getWalletAccountById(offset, limit);
    setCurrentPage(1);
  };

  const transformedData = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Name",
          value: walletAccountDetails?.walletProductName ?? "-",
          isTag: true,
        },
        {
          name: "Product Currency",
          value:
            walletAccountDetails?.savingsAccountData?.currency?.displayLabel ??
            "-",
          isTag: true,
        },
        {
          name: "Activation Status",
          value: walletAccountDetails?.savingsAccountData?.status?.value ?? "-",
          isTag: true,
        },
        {
          name: "Created Date",
          value:
            BOM.FormatArrayDate(
              walletAccountDetails?.savingsAccountData?.timeline
                ?.submittedOnDate,
            ) ?? "-",
        },
      ],
    },

    {
      section: "Customer Eligibility",
      items: [
        {
          name: "KYC Level",
          value: walletAccountDetails?.kycLevel
            ? walletAccountDetails?.kycLevel?.value
            : "-",
          isTag: true,
        },
        {
          name: "Transaction Restriction",
          value: walletAccountDetails?.transactionRestrictionType
            ? walletAccountDetails?.transactionRestrictionType?.value
            : "-",
          isTagArray: true,
        },

        {
          name: "Customer Segment",
          value: walletAccountDetails?.customerSegmentType
            ? walletAccountDetails?.customerSegmentType?.value
            : "-",
          isTagArray: true,
        },
      ],
    },
    {
      section: "Account Parameters",
      items: [
        {
          name: "Account Name",
          value: walletAccountDetails?.name ? walletAccountDetails?.name : "-",
        },

        {
          name: "Statement Cycle",
          value: walletAccountDetails?.statementCycleType
            ? walletAccountDetails?.statementCycleType?.value
            : "-",
          isTagArray: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (walletAccountData[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 1,
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        state={state}
        userData={userData}
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
        savingsAccountData={walletAccountDetails?.savingsAccountData}
        walletAccountDetails={walletAccountDetails}
        currentPage={currentPage}
        tableCount={tableCount}
        totalItems={totalItems}
        setCurrentPage={setCurrentPage}
        onRefresh={onRefresh}
      />
    ),
    subWallet: (
      <SubWallet
        subWalletList={subWalletListData}
        state={state}
        userData={userData}
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
      />
    ),
    charges: (
      <Charges
        chargesList={chargesList}
        state={state}
        userData={userData}
        refreshDetail={onRefresh}
        walletAccountDetails={walletAccountDetails}
        onRefresh={onRefresh}
        // refreshNote={getNotes}
      />
    ),
  };

  return (
    <MainLayout pageItems={staticConfig.detailWalletAccountBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.detailWalletAccount}
        createPageTitle={labelConfig.detailWalletAccount}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>
            </Row>

            <AccountFacility
              status={walletAccountDetails?.savingsAccountData?.status?.value}
              name={walletAccountDetails?.savingsAccountData?.clientName}
              nubanNumber={walletAccountDetails?.nubanNumber}
              amount={
                walletAccountDetails?.savingsAccountData?.summary
                  ?.availableBalance
              }
              interest={walletAccountDetails?.maturityValue}
              currencyCode={
                walletAccountDetails?.savingsAccountData?.currency?.code
              }
              interestPerAnnum={walletAccountDetails?.interestRate}
              aggregateBalance={walletAccountDetails?.aggregateBalance}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData?.map((section, index) => (
                <Col style={{}}>
                  <Collapse
                    className="custom-collapse"
                    // expandIconPosition="start"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section?.items?.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index),
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
        <Card
          className="custom-transaction-tab"
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ViewWalletAccount);
